<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">English</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Doctorate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Arts(Hons) English</td>
                            <td class="time">Master of Arts (English)</td>
                            <td class="time">Ph.D English</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Art & Humanities</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Arts (Hons) English </b>
                    – The Bachelor of Arts (Hons) in English offered by ARNI School Of Art & Humanities is a three-year
                    undergraduate program designed to provide students with an in-depth understanding of English
                    literature, language, and critical analysis. This program enhances students' appreciation of
                    literary texts, strengthens their language skills, and fosters creative and analytical thinking.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundations of English Studies
                </p>
                <ul>
                    <li> History of English Literature (Old & Middle English)</li>
                    <li> Introduction to Poetry and Drama</li>
                    <li> English Grammar & Composition</li>
                    <li> European Classical Literature (Homer, Sophocles, Plato)</li>
                    <li> Indian Classical Literature (Kalidasa, Vyasa, Bhasa)</li>
                    <li> Environmental Studies</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Evolution of Literature
                </p>
                <ul>
                    <li> British Literature (14th to 17th Century) – Chaucer, Shakespeare, Milton</li>
                    <li> Prose and Fiction – Short Stories & Essays</li>
                    <li> Introduction to Literary Forms and Terms</li>
                    <li> Creative Writing: Fiction & Poetry</li>
                    <li> Communication Skills & Public Speaking</li>
                    <li> Forms of Popular Fiction</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Evolution of Literature
                </p>
                <ul>
                    <li> British Literature (18th & 19th Century) – Romantic & Victorian Age</li>
                    <li> American Literature (Poetry, Drama, Prose)</li>
                    <li> Indian Writing in English (Tagore, R.K. Narayan, Anita Desai)</li>
                    <li> Women’s Writing & Feminist Literature</li>
                    <li> Linguistics & Phonetics</li>
                    <li> Research Methodology & Academic Writing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Modern & Postmodern Literature
                </p>
                <ul>
                    <li> British Literature (20th & 21st Century) – Modernism & Postmodernism</li>
                    <li> Postcolonial Literature (Chinua Achebe, Salman Rushdie, Arundhati Roy)</li>
                    <li> Literary Criticism & Theory (Marxism, Structuralism, Poststructuralism)</li>
                    <li> World Literature (Gabriel García Márquez, Franz Kafka, Leo Tolstoy)</li>
                    <li> Elective - I</li>
                    <li> Nineteenth Century European Realism</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b> : Specialized Studies & Research
                </p>
                <ul>
                    <li> Shakespearean Drama – Tragedies & Comedies</li>
                    <li> Translation Studies & Comparative Literature</li>
                    <li> Popular Literature (Graphic Novels, Detective Fiction, Science Fiction)</li>
                    <li> Writing for Media (Scriptwriting, Blogging, Copywriting)</li>
                    <li> Professional Ethics & Soft Skills Development</li>
                    <li> Anglo-American Writing from</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b> : Advanced Literary Studies & Career
                    Preparation
                </p>
                <ul>
                    <li> Modern Indian Literature in English & Translation</li>
                    <li> Literature and Society (Dalit Literature, LGBTQ+ Writing, Eco-criticism)</li>
                    <li> English Language Teaching (ELT) & Applied Linguistics</li>
                    <li> Digital Humanities & New Media Writing</li>
                    <li> Dissertation / Research Paper Submission</li>
                    <li> Career Preparation & Resume Building</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts (English) </b>
                    – The Master of Arts (Hons) in English offered by ARNI School of Art & Humanities s a two-year
                    postgraduate program designed to provide an advanced understanding of English literature, literary
                    theory, linguistics, and critical analysis. This program focuses on refining analytical and research
                    skills, exploring interdisciplinary aspects of literature, and enhancing proficiency in academic and
                    creative writing.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundations of Advanced Literary
                    Studies
                </p>
                <ul>
                    <li> British Literature: From Renaissance to Romanticism</li>
                    <li> Advanced Literary Theory: Structuralism, Poststructuralism, Deconstruction</li>
                    <li> Research Methodology in Literature & Humanities</li>
                    <li> Indian Writing in English and Translation Studies</li>
                    <li> Academic Writing and Rhetorical Analysis</li>
                    <li> Elective: Comparative Literature / Gender Studies</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Exploring Global Perspectives
                </p>
                <ul>
                    <li> British Literature: Victorian to Contemporary</li>
                    <li> Postcolonial Literature & Cultural Studies</li>
                    <li> American Literature: From Puritanism to Postmodernism</li>
                    <li> Linguistics & Semiotics</li>
                    <li> Literary Criticism: Marxism, Psychoanalysis, Feminism, Queer Theory</li>
                    <li> Elective: English Language Teaching (ELT) / Digital Humanities</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Specialization & Interdisciplinary
                    Studies
                </p>
                <ul>
                    <li> Modern Indian Literature & Dalit Literature</li>
                    <li> World Literature: Latin American, African, and European Classics</li>
                    <li> Film & Literature: Adaptation Theory and Visual Narratives</li>
                    <li> Popular Literature: Science Fiction, Graphic Novels, Detective Fiction</li>
                    <li> Translation Theory & Practice</li>
                    <li> Elective: Media Studies / Professional Writing & Editing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Research & Professional Development
                </p>
                <ul>
                    <li> Literary Journalism and Creative Writing</li>
                    <li> Literature and the Visual Arts in Europe</li>
                    <li> Literary Ethics and Globalization</li>
                    <li> Career Preparation & Publishing Industry Insights</li>
                    <li> Dissertation / Thesis Submission</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Ph.D English </b>
                    – The Ph.D. in English at ARNI University is a rigorous and research-intensive doctoral program
                    aimed at scholars interested in literary studies, critical theory, linguistics, cultural studies,
                    and interdisciplinary research. The program is designed to cultivate advanced research skills,
                    academic writing proficiency, and critical thinking, enabling scholars to make significant
                    contributions to the field of English literature and language studies.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Research Foundations & Theoretical
                    Frameworks
                </p>
                <ul>
                    <li> Research Methodology in Literature & Humanities</li>
                    <li> Advanced Literary Theory: Postmodernism, Ecocriticism, Posthumanism</li>
                    <li> Contemporary Critical Perspectives: Marxism, Feminism, Psychoanalysis, Structuralism</li>
                    <li> Academic Writing & Research Ethics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Interdisciplinary Approaches &
                    Specialized Research Areas
                </p>
                <ul>
                    <li> Comparative Literature & Translation Studies</li>
                    <li> Linguistics, Semiotics & Discourse Analysis</li>
                    <li> World Literature & Global Narratives</li>
                    <li> Digital Humanities & Media Studies</li>
                    <li> Research Proposal Development & Approval</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Literature, Culture & Society
                </p>
                <ul>
                    <li> Postcolonial Literature & Identity Politics</li>
                    <li> Cultural Studies: Race, Gender, Ethnicity, and Media Representation</li>
                    <li> Popular Literature: Science Fiction, Graphic Novels, and Dystopian Narratives</li>
                    <li> Teaching English as a Second Language (TESL)</li>
                    <li> Conference Presentation & Paper Submission</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Research & Dissertation Development
                </p>
                <ul>
                    <li> Advanced Research Writing & Journal Publications</li>
                    <li> Dissertation Chapter Submission & Peer Review</li>
                    <li> Workshops on Research Presentation Techniques</li>
                    <li> Field Study / Data Collection / Archival Research</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b> : Dissertation Completion
                </p>
                <ul>
                    <li> Dissertation Finalization & Editing</li>
                    <li> Pre-Submission Viva & Research Evaluation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b> : Career Readiness
                </p>
                <ul>
                    <li> Submission of Research Thesis</li>
                    <li> Final Viva Voce & Defense</li>
                </ul>
            </div>


        </div>

    </div>
</section>
